import { SurveyRecordVerificationState } from '../../generated/graphql'
import { gray } from '../../services/config'
import { Maybe } from '../../types/types'
import styles from './SurveyRecordVerificationState.module.scss'

interface SurveyRecordVerificationStateProps {
    state: Maybe<SurveyRecordVerificationState>
}

export const SurveyRecordVerificationStateDisplay = (props: SurveyRecordVerificationStateProps) => {
    const { state } = props
    const backgroundColor = state?.backgroundColor ?? gray
    return (
        <div className={styles.SurveyRecordVerificationState} style={{ backgroundColor }}>
            {state?.name}
        </div>
    )
}
